module.exports = __webpack_public_path__ + "media/images/writer/community/pc-title@3x-23426ec015c4e58527085795e0fb2927.png";